import React, { Component } from 'react'
import Android from './Android'

class NativeAppPromo extends Component {
  shouldComponentUpdate () {
    return false
  }

  detectOperatingSystem () {
    let os = ''
    if (window.navigator.userAgent.match(/android/i)) {
      os = 'android'
    }

    return os
  }

  getPromoComponent (os, config) {
    const {
      widget: widgetConfig
    } = this.props
    let component

    if (os && config) {
      const components = {
        android: () => {
          const widget = Object.assign({}, widgetConfig, {name: 'androidAppPromo'})
          return <Android widget={widget} config={config}/>
        }
      }

      if (components[os]) {
        component = components[os]
      }
    }

    return component
  }

  render () {
    if (typeof window !== 'undefined') {
      const {
        widget: {
          meta
        }
      } = this.props
      const os = this.detectOperatingSystem()
      const config = meta[os]

      const $component = this.getPromoComponent(os, config)
      return $component ? <$component/> : null
    }
  }
}

export default NativeAppPromo
